import { registerDiagnosticCallback } from "accelerator-common/lib/registerDiagnosticCallback";
import { CopilotHubMainModule } from "copilot-hub-main-module";
import { HybridspaceMainModule } from "hybridspace-main-module";
import { getApplicationSettings } from "owa-application-settings";
import controlIconRegistration from "owa-control-icons/lib/data/controlIconsRegistration";
import { getEnabledFlightsWithPrefix } from "owa-feature-flags";
import { markEnd, markStart } from "owa-performance";
import { type OwaWorkload } from "owa-workloads";
import { CHANGE_ORGANIZER_MODULE_NAME, PLACES_APP_NAME } from "places-common-strings";
import { lazySetupPlacesPostRender } from "places-post-boot";
import { initializeState } from "./initializeState";

import type { BootstrapOptions } from "owa-bootstrap";
import type { SessionData } from "owa-service/lib/types/SessionData";
import type { JSX } from "react";

export default function getBootstrapOptions(sessionPromise: Promise<SessionData | undefined>): BootstrapOptions & {
    // This was added to enforce the BootstrapOptions.renderMainComponent type for owa-start type.
    renderMainComponent: () => JSX.Element;
} {
    return {
        initializeState: async (...args) => {
            try {
                markStart("PlacesInitializeState");
                return await initializeState(...args);
            }
            finally {
                markEnd("PlacesInitializeState");
            }
        },
        renderMainComponent: () => showCopilotHub() ? <CopilotHubMainModule /> : <HybridspaceMainModule />,
        getModuleName: () => {
            if (document.documentElement.dataset.changeOrganizer === "1") {
                return CHANGE_ORGANIZER_MODULE_NAME;
            }
            return PLACES_APP_NAME;
        },
        iconFonts: [controlIconRegistration],
        sessionPromise,
        workload: 16777216,
        swConfig: {
            app: "places",
            expectedXAppNameHeader: "Places",
        },
        postLazyAction: lazySetupPlacesPostRender,
    };
}

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function registerDiagnosticCallback called at module scope is not allowed. This may cause unwanted side effects. */
registerDiagnosticCallback(() => ({
    key: "Flights",
    value: JSON.stringify(getEnabledFlightsWithPrefix("msplaces").concat(getEnabledFlightsWithPrefix("places"))),
}));

function showCopilotHub() {
    return (getApplicationSettings("PrepareModule").enabled &&
        (window.location.pathname.indexOf("/places/copilothub") == 0 ||
            window.location.pathname.indexOf("/hosted/places/copilothub") == 0));
}
